import React from 'react';
import { useLocation } from '@reach/router';
import { HeaderButtonBack } from '@avangard/ui/core';

import { useAuthLayout } from '@modules/layout/templates';

const Back = (): React.ReactElement | null => {
    const location = useLocation();

    const { onBack, setBack } = useAuthLayout();

    return React.useMemo(() => {
        if (!onBack) {
            return null;
        }

        const handleBack = () => {
            onBack();
            setBack(null);
        };

        return <HeaderButtonBack onClick={handleBack} />;
    }, [location, onBack]);
};

export { Back };
